const SESSION_NOTE_TYPES = new Set([
  'Session Note',
  'Session Note - Positive',
  'Session Note - Delta',
]);

export const isSessionNoteType = (type?: string | null): boolean =>
  SESSION_NOTE_TYPES.has(type || '');

export default SESSION_NOTE_TYPES;

